export default {"src":"/_next/static/media/icUpTrend.dd309264.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};